/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Unlock_Card1_DescInputs */

const en_home_unlock_card1_desc = /** @type {(inputs: Home_Unlock_Card1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View and download your policy documents, update your profile, manage travellers on your plan, and reset your password — all from one place.`)
};

const fr_home_unlock_card1_desc = /** @type {(inputs: Home_Unlock_Card1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultez et téléchargez vos documents de police, mettez à jour votre profil, gérez les voyageurs sur votre régime et réinitialisez votre mot de passe — le tout au même endroit.`)
};

/**
* | output |
* | --- |
* | "View and download your policy documents, update your profile, manage travellers on your plan, and reset your password — all from one place." |
*
* @param {Home_Unlock_Card1_DescInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_unlock_card1_desc = /** @type {((inputs?: Home_Unlock_Card1_DescInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Unlock_Card1_DescInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_unlock_card1_desc(inputs)
	return fr_home_unlock_card1_desc(inputs)
});